import { Icon, IconName } from '@orbita-ui/core';
import React, { Ref } from 'react';
import styled from 'styled-components';

type BiIconName = `bi-${string}`;

export type AppIconName = BiIconName | IconName;

type IconSize = 'S' | 'M' | 'L';
type ColorVariants =
  | 'primary'
  | 'primaryStronger'
  | 'primaryStrong'
  | 'secondary'
  | 'secondaryStronger'
  | 'secondaryStrong'
  | 'neutral'
  | 'neutralWeak'
  | 'neutralWeaker'
  | 'neutralStrong'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'purple'
  | 'orange'
  | 'pink'
  | 'lightblue';
interface IconBaseProps
  extends Omit<
    React.SVGProps<SVGSVGElement>,
    'version' | 'xmlns' | 'xmlnsXlink' | 'viewBox' | 'ref' | 'color'
  > {
  alt?: string;
  color: ColorVariants;
  size?: IconSize;
  ref?: Ref<SVGSVGElement>;
}
interface IconProps extends Omit<IconBaseProps, 'color' | 'size' | 'children' | 'name'> {
  name: AppIconName;
  color?: ColorVariants;
  size?: IconSize;
}
function checkBiIcon(icon: string): boolean {
  return icon.startsWith('bi-');
}

const StyledIcon = styled.i`
  color: inherit;
  font-size: 1.5rem;

  &::before {
    line-height: 1.5rem;
  }
`;

export const AppIcon: React.FC<IconProps> = ({ name, ...props }) => {
  if (checkBiIcon(name)) {
    return <StyledIcon className={name} />;
  }
  return <Icon name={name as IconName} {...props} />;
};
